import { TypographySM } from "@/components/typography/SM";

interface Props {
  numberOfCompleted: number;
  completedPercentage: number;
}

export function OnboardingProgress({
  numberOfCompleted,
  completedPercentage
}: Props) {
  return (
    <div
      className="flex flex-col gap-1.5"
      style={{ width: "clamp(4rem, 70%, 20rem)" }}
    >
      <TypographySM className="text-brand-primary">
        {numberOfCompleted} / 5
      </TypographySM>
      <div className="w-full h-2 dark:bg-brand-gray-700 rounded">
        <div
          className="h-full bg-brand-primary rounded transition-all"
          style={{
            width: `${completedPercentage}%`
          }}
        />
      </div>
    </div>
  );
}
